import React, { useState } from 'react';
import { ScannerInterface } from './components/ScannerInterface';
import { ProductionOrder } from './components/ProductionOrder';
import { Header } from './components/Header';
import { PasswordProtection } from './components/PasswordProtection';
import { Impressum } from './components/Impressum';
import { ScanIcon, PackageIcon, QrCodeIcon, InfoIcon } from 'lucide-react';
interface ProductionProgress {
  currentStepIndex: number;
  completedIngredients: string[];
}
// Speichert den Fortschritt pro Charge
interface ProductionState {
  [orderId: string]: ProductionProgress;
}
export function App() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [scannedOrderId, setScannedOrderId] = useState<string | null>(null);
  const [productionState, setProductionState] = useState<ProductionState>({});
  const [showImpressum, setShowImpressum] = useState(false);
  const handleScan = (orderId: string) => {
    setScannedOrderId(orderId);
  };
  const handleReset = () => {
    setScannedOrderId(null);
  };
  const handleSaveProgress = (orderId: string, progress: ProductionProgress) => {
    setProductionState(prev => ({
      ...prev,
      [orderId]: progress
    }));
  };
  if (!isUnlocked) {
    return <div className="mx-auto bg-gray-100" style={{
      width: '480px',
      height: '800px'
    }} data-id="element-0">
        <PasswordProtection onUnlock={() => setIsUnlocked(true)} data-id="element-1" />
        <div className="absolute bottom-4 right-4" data-id="element-2">
          <button onClick={() => setShowImpressum(true)} className="text-gray-500 hover:text-gray-700 flex items-center gap-1 text-xs" data-id="element-3">
            <InfoIcon size={14} data-id="element-4" />
            Impressum
          </button>
        </div>
        {showImpressum && <Impressum onClose={() => setShowImpressum(false)} data-id="element-5" />}
      </div>;
  }
  return <div className="flex flex-col mx-auto bg-gray-100 overflow-hidden" style={{
    width: '480px',
    height: '800px'
  }} data-id="element-6">
      <Header data-id="element-7" />
      <main className="flex-1 p-2" data-id="element-8">
        {!scannedOrderId ? <>
            <ScannerInterface onScan={handleScan} data-id="element-9" />
          </> : <ProductionOrder orderId={scannedOrderId} onReset={handleReset} savedProgress={productionState[scannedOrderId]} onSaveProgress={progress => handleSaveProgress(scannedOrderId, progress)} data-id="element-10" />}
      </main>
      <div className="p-2 text-center" data-id="element-11">
        <button onClick={() => setShowImpressum(true)} className="text-gray-500 hover:text-gray-700 text-xs" data-id="element-12">
          Impressum
        </button>
      </div>
      {showImpressum && <Impressum onClose={() => setShowImpressum(false)} data-id="element-13" />}
    </div>;
}